import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { IProvider } from 'src/app/pages/gestion/providers/provider.interface';
@Injectable({
  providedIn: 'root'
})
export class ProviderSelectionService {
  data$: Subject<IProvider>;
  data = {} as IProvider;

  constructor() {
    this.data$ = new Subject();
  }

  getData$(): Observable<IProvider> {
    return this.data$.asObservable();
  }

  setData(data: IProvider) {
    this.data = {
      ...data
    } as IProvider;

    this.data$.next(this.data);
  }

  emptyData() {
    this.data = {} as IProvider;

    this.data$.next(this.data);
  }
}
